export const UPDATE = "notifications/UPDATE";
export const UPDATE_ONE = "notifications/UPDATE_ONE";
export const APPEND = "notifications/APPEND";
export const EMPTY = "notifications/EMPTY";
export const LOADING = "notifications/LOADING";
export const READ_ITEM = "notifications/READ_ITEM";
export const READ_ALL = "notifications/READ_ALL";
